// http://kazupon.github.io/vue-i18n/guide/started.html#javascript

import VueI18n from 'vue-i18n'
import Vue from 'vue';

Vue.use(VueI18n)

const numberFormats = {
    'en-US': {
        currency: {
            style: 'currency',
            currency: 'USD'
        }
    },
    'pl-PL': {
        currency: {
            style: 'currency',
            currency: 'PLN',
            currencyDisplay: 'symbol'
        }
    }
}

const messages = {
    'pl-PL': {
        'orderStatus': {
            "UNPAID": "Oczekuje na płatność",
            "PAID": "Zapłacone"
        },
        'uploadProducts': {
            "noItem": "Towar nie istnieje"
        },
        'itemsType': {
            "vodka": "Wódka",
            "wineRed": "Wino czerwone",
            "wineWhite": "Wino białe",
            "wineSpark": "Wino musujące",
            "wineDeser": "Wino deserowe",
            "wineEco": "Wino Eco"
        }
    }
}

const dateTimeFormats = {
    'pl-PL': {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        medium: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric'
        }
    }
}

export const i18n = new VueI18n({
    locale: 'pl-PL', // set locale
    numberFormats,
    dateTimeFormats,
    messages
})